import { getEstimate } from "../../services/estimateServices";
import { updateLead } from "../../services/leadServices";
import { ESTIMATE_ID_PARAM, SCREEN } from "../../utils/constants";
import { customField, fileUploadChannel, form, setCustomField, setCustomFields, setEstimateInfo, setLeadInfo, setLeadTextId, setProgressQuestion, setProviderId } from "../../utils/variables";
import { loadSelectedProcedures } from "../../views/components/selectedProcedures";
import { handleInstantQuoteSummary, instantQuoteSummaryListeners } from "../events/instantQuoteSummaryListeners";
import { getClassScreen, navigate, params } from "../events/movePages";

import { uploadPhotosListeners } from "../events/uploadPhotosListeners";
import { loadCustomFields } from "./consultActions";

export async function loadInstantQuoteSummaryLandingPage() {
    const estimates = await getEstimate(params(ESTIMATE_ID_PARAM));

    if (estimates) {
        setEstimateInfo(estimates.data);
        loadSelectedProcedures();
        instantQuoteSummaryListeners();
        handleInstantQuoteSummary();
        
        setLeadTextId(estimates.data.lead.text_id);
        setLeadInfo(estimates.data.lead);
        setProviderId(estimates.data.staff_id);

        let refreshBtnDom = document.querySelector('.instant_quote_summary__container .refresh.instant_quote--again');
        let phoneBtnDom = document.querySelector('.instant_quote_summary__container .phone.instant_quote--again');

        if (refreshBtnDom) refreshBtnDom.style.visibility = 'hidden';
        if (phoneBtnDom) phoneBtnDom.style.visibility = 'hidden';

        document.querySelector(getClassScreen(SCREEN.INSTANT_QUOTE_SUMMARY)).style.transition = 'none';
        navigate(SCREEN.INSTANT_QUOTE_SUMMARY);

    /* On click Still interested, request a consultation  */
    document.querySelector(
        '.consultSummary__container .consult-summary__btn'
    ).onclick = (e) => {
        e.preventDefault();
        if (form.form?.custom_fields.length > 0) {
            let item = form.form.custom_fields[0];
            setCustomFields(form.form.custom_fields.filter(custom_field => custom_field.id !== item.id));
            setCustomField(item);
            setProgressQuestion({
                currentQuestion: 1,
                total: form.form.custom_fields.length,
                progress: ((1 / form.form.custom_fields.length) * 100)
            });
            loadCustomFields(customField);
        }
        else if (fileUploadChannel) {
            uploadPhotosListeners();
            navigate(SCREEN.UPLOAD_PHOTOS);
        } else {
            navigate(SCREEN.THE_END);
        }
    };
    }
}